import React from "react";
import { useNavigate } from "react-router-dom";
import "./ThankYouPage.css"; // Optional: for styling
import videoImg from "../../assets/images/play-video.png";

const ThankYouPage = () => {
  const navigate = useNavigate();
  const email = sessionStorage.getItem("login_email");

  const handleBackToLogin = () => {
    navigate("/");
  };

  return (
    <div className="thank-you-container">
      <h1>Thank You!</h1>
      <strong>{email}</strong>
      <img src={videoImg} alt="video" />
      <p>
        Our records show that this email address has already submitted an email,
        please be attentive to your email for further communications. Thank you
        for your interest.
      </p>
      <p>
        If this is not your email address you can go to the login and enter your
        email address.
      </p>
      <button onClick={handleBackToLogin}>Back to Login</button>
    </div>
  );
};

export default ThankYouPage;
